import React, { Component } from 'react';

import MainInterface from './components/MainInterface';
import { SessionContextProvider } from "./context/session-context";

import './App.css';

class App extends Component {

  constructor(props) {
    super(props);
  }
    render() {
      return (   
          <SessionContextProvider>
            <MainInterface />
          </SessionContextProvider>    
        );
    }
}

export default App;
